import { Helmet } from 'react-helmet';
import { useEffect } from 'react';
import { usePostMessage } from 'spectacle-ui-game-bridge-react';
import { getPath } from '../../config';
import LoadingIndicator from '../../components/loadingIndicator/loadingIndicator';
import useContentForBuild from '../../hooks/useContentForBuild';
import useDlogLoginFunnel from '../../hooks/useDlogLoginFunnel';
import ExternalLinkIcon from '../../icons/ExternalLinkIcon';
import CloseIcon from '../../icons/CloseIcon';

export default function Terms() {
  const openUrl = usePostMessage('openUrl');
  const closeWebView = usePostMessage('closeWebView');
  const dlog = useDlogLoginFunnel();
  const [content, loading] = useContentForBuild();

  useEffect(() => {
    dlog({
      phase: 'EULA',
      action: 'Render',
    });
  });

  const handleUrl = (e: any) => {
    e.preventDefault();
    const href = e.target.href;

    openUrl(href);
  };

  const closeTerms = (e: any) => {
    e.preventDefault();

    closeWebView();
  };

  return (
    <>
      <Helmet>
        <title>{content?.reviewTerms}</title>
      </Helmet>
      {loading && (
        <div className="loading-mask">
          <LoadingIndicator />
        </div>
      )}
      {content && (
        <div className="centered">
          <div className="frame frame--extra-padding">
            <div className="frame__corner-tl" />
            <div className="frame__corner-tr" />
            <div className="frame__corner-bl" />
            <div className="frame__corner-br" />
            <div className="logo-inline">
              <img src={getPath('menu_cod_logo_lg')} alt="Call of Duty" />
            </div>
            <div className="checkbox">
              <div>
                <label htmlFor="serviceAcceptance">
                  <a onClick={handleUrl} href={content.serviceAgreementUrl}>
                    {content.serviceCta} <ExternalLinkIcon className="external-link__icon" />
                  </a>
                </label>
              </div>
            </div>
            <div className="checkbox">
              <div>
                <label htmlFor="termsOfUseAcceptance">
                  <a onClick={handleUrl} href={content.termsOfUseAgreementUrl}>
                    {content.termsOfUseCta} <ExternalLinkIcon className="external-link__icon" />
                  </a>
                </label>
              </div>
            </div>
            <div className="checkbox">
              <div>
                <label htmlFor="privacyPolicyAcceptance">
                  <a onClick={handleUrl} href={content.privacyPolicyAgreementUrl}>
                    {content.privacyPolicyCta} <ExternalLinkIcon className="external-link__icon" />
                  </a>
                </label>
              </div>
            </div>
            <div className="checkbox">
              <div>
                <label htmlFor="codeOfConductAcceptance">
                  <a onClick={handleUrl} href={content.codeOfConductAgreementUrl}>
                    {content.codeOfConductCta} <ExternalLinkIcon className="external-link__icon" />
                  </a>
                </label>
              </div>
            </div>
          </div>
        </div>
      )}
      <button className="close" onClick={closeTerms}>
        <CloseIcon className="external-link__icon" />
      </button>
    </>
  );
}
